<template >
	<div class="lm-dropdown-wrap">
		<div :class="['lm-dropdown', { 'open': statusDropdown, }]">
		<div class="lm-dropdown">

			<div ref="dropdownSelect" class="lm-dropdown-selected form-control"
					 tabindex="0"
					 @click="openDropdown"
			>{{ dataActiveSelect }}</div>

			<i ref="icon" class="lm-dropdown-icon" @click="openDropdown" />

			<div v-if="values.length" ref="dropdownMenu" class="lm-dropdown-menu">
				<ul>
					<li v-for="(field, idx) in values" :key="idx">
						<span @click="selectVal(field)" class="lm-dropdown-menu--item">
							{{ field[colNameFromDatabase] }}
						</span>
					</li>

				</ul>
			</div>
		</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			values: {
				type: Array,
				required: true,
				default: [],
			},
			dropdownOpen: {
				type: Boolean,
				required: false,
				default: false,
			},
			activeSelect: {
				type: String,
				required: false,
				default: '',
			},
			colNameFromDatabase: {
				type: String,
				required: false,
				default: 'name'
			}
		},
		data: () => ({
			dataActiveSelect: '',
			statusDropdown: false,
		}),
		watch: {
			activeSelect(){
				this.dataActiveSelect = this.activeSelect;
			},
			dropdownOpen(){
				this.statusDropdown = this.dropdownOpen;
			},
			statusDropdown(){
				this.statusDropdown ? this.addListenerWindow() : this.removeListenerWindow();
			}
		},
		methods: {
			selectVal(field) {
				this.dataActiveSelect = field.name;
				this.$emit('fieldValue', field);
				this.statusDropdown = false;
			},
			openDropdown() {
				this.statusDropdown = !this.statusDropdown;
			},
			listenerWindow(e) {
				if (e.target !== this.$refs.dropdownSelect &&
					e.target !== this.$refs.dropdownMenu){
					this.statusDropdown = false;
					this.removeListenerWindow();
				}
			},
			addListenerWindow() {
				document.addEventListener('click', this.listenerWindow);
			},
			removeListenerWindow() {
				document.removeEventListener('click', this.listenerWindow);
			},
		},
		mounted() {
			this.dataActiveSelect = this.values[0][this.colNameFromDatabase];
		}
	}
</script>

